define( [
	"../core",
	"../ajax",
	"../event"
], function( jQuery ) {

"use strict";

jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/deprecated/ajax-event-alias.js
// module id = 669
// module chunks = 1